import util from '@bmp-vue/core/api/util'

const controller = 'CentralEmailMultiplo'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  EnviarEmail: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmailMultiplo', dto)
  },
  EnviarEmailByParceiro: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmailByParceiro', dto)
  },
  EnviarEmailByParceiroBucket: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmailByParceiroBucket', dto)
  },
})
